import { db } from '../firebase/config'

/**
 * Flip a subtask's Status. Used by both the inline SubTasks row and the
 * TaskEditor sidebar so they behave identically.
 *
 * Materials no longer live on subtasks (they moved to the household —
 * `AdressMaterials`), so a status change is now a plain field update with no
 * stock side-effects. See docs/features/household-materials.md.
 */
const useSubtaskStatusChange = () => {
    const runStatusChange = async (subtask, newStatus) => {
        if (!subtask) return { ok: false }

        const oldStatus = subtask.Status || 'toDo'
        if (oldStatus === newStatus) return { ok: false }

        await db.collection('Tasks').doc(subtask.docid).update({ Status: newStatus })
        return { ok: true }
    }

    return { runStatusChange }
}

export default useSubtaskStatusChange
